import {
  ServiceRequestCustomerUpdateStatusDetails,
  ServiceRequestListCustomerUpdateStatusDTO,
} from '@commenda/types/src/service-request/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { API_BASE_PATH } from './constants';

export const useServiceRequestUpdateStatus = (
  options: ServiceRequestListCustomerUpdateStatusDTO
) => {
  const { assignedUserId, daysSinceLastUpdate } = options;
  const query = new URLSearchParams();

  query.append('assignedUserId', assignedUserId);
  
  if (daysSinceLastUpdate) {
    query.append('daysSinceLastUpdate', daysSinceLastUpdate.toString());
  }

  const {
    data,
    error,
    mutate,
  }: {
    data?: ServiceRequestCustomerUpdateStatusDetails[];
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    assignedUserId ? `${API_BASE_PATH}/list-customer-update-status?${query.toString()}` : null,
    SWRFetcher(
      {
        method: 'GET',
      },
      undefined
    )
  );

  return {
    data,
    error,
    mutate,
  };
}; 